export const TEST_ID = 'intervalOemDefault';

export const RESET_BUTTON_TEST_ID = 'intervalResetToDefaultButton';
